import * as React from 'react';
import { Grid, Select, MenuItem } from '@material-ui/core';
import { QuestionClassTypes, AutoCalculationOperators } from '../../constants/data';





export default class HorizontalAutoCalculationComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            configuration: {}
        }
        this.handleSetOneChange = this.handleSetOneChange.bind(this);
        this.handleSetTwoChange = this.handleSetTwoChange.bind(this);
        this.handleOperator = this.handleOperator.bind(this);
    }


    componentDidMount() {
        this.setState({ configuration: this.props.configuration });
    }
    UNSAFE_componentWillReceiveProps(nextProps: any) {
        this.setState({ configuration: nextProps.configuration });
    }

    handleSetOneChange = (e: any) => {
        this.props.onSetOneChange(e.target.value);
    }
    handleSetTwoChange = (e: any) => {
        this.props.onSetTwoChange(e.target.value);
    }
    handleOperator = (e: any) => {
        this.props.onOperatorChange(e.target.value);
    }

    render() {
        return (
            <>
                {/* <Grid xs={6} item={true}> */}
                <Grid container={true} spacing={8} xs={12} direction="row" justify="center" alignItems="center">
                    <Grid item={true} xs={3} >
                        <span className="padding-top-50 dialogLabel"> Set 3</span>

                    </Grid>
                    <Grid item={true} xs={1} >
                        <span className="padding-top-50">=</span>
                    </Grid>
                    <Grid xs={8} item={true}>
                        <Grid item={true} xs={12}>
                            <Select
                                fullWidth={true}
                                value={this.state.configuration && this.state.configuration.operand_one_set}
                                onChange={this.handleSetOneChange}
                            >
                                {
                                    QuestionClassTypes.filter((ct: any) => {
                                        return ct.value < 3
                                    }).map((operator: any) => {
                                        return (
                                            <MenuItem key={operator.value} value={operator.value}>
                                                {operator.text}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <Select
                                fullWidth={true}
                                value={this.state.configuration && this.state.configuration.operator}
                                onChange={this.handleOperator}
                            >
                                {
                                    AutoCalculationOperators.map((operator: any) => {
                                        return (
                                            <MenuItem key={operator.value} value={operator.value}>
                                                {operator.text}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid item={true} xs={12}>
                            <Select
                                fullWidth={true}
                                value={this.state.configuration && this.state.configuration.operand_two_set}
                                onChange={this.handleSetTwoChange}
                            >
                                {
                                    QuestionClassTypes.filter((ct: any) => {
                                        return ct.value < 3
                                    }).map((operator: any) => {
                                        return (
                                            <MenuItem key={operator.value} value={operator.value}>
                                                {operator.text}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </Grid>

                {/* </Grid> */}
            </>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/questions/HorizontalAutoCalculationComponent.tsx